module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/tankodrome-lvl3-75.e003c9bf.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/tankodrome-lvl3-75.png
// module id = 3560
// module chunks = 11